// @flow
import { useCallback, useMemo } from "react";
import type { GridProps } from "./types";
import { GRID_IMAGE_HEIGHT, TOTAL_IMAGES_IN_A_PAGE } from "~/src/root/components/ResultImageGrid/VirtualResultsGrid/const";
import { renderGridItem } from "~/src/root/components/ResultImageGrid/VirtualResultsGrid/GridItem/renderGridItem";

export default (props: GridProps) => {
	const {
		images,
		selected,
		selectionAction,
		onLoadMore,
		useImageClientSize,
		isMultiple,
		allowSelect,
		customPreviewInfo,
		alwaysShowPreviewInfo,
		hasMore,
		isLoading
	} = props;


	const totalImagesInPage = onLoadMore ? TOTAL_IMAGES_IN_A_PAGE : 4;
	const totalImages = images?.length + (hasMore || isLoading ? totalImagesInPage : 0);
	const isImageLoaded = useCallback((index: number) => !!images[index], [images]);

	return useMemo(
		() => ({
			itemHeight: GRID_IMAGE_HEIGHT,
			totalItems: totalImages,
			renderItemComponent: renderGridItem,
			isItemLoaded: isImageLoaded,
			items: selected,
			loadMore: onLoadMore || (() => null),
			itemProps: {
				items: images,
				total: totalImages,
				selected,
				selectionAction,
				useImageClientSize,
				isMultiple,
				allowSelect,
				customPreviewInfo,
				alwaysShowPreviewInfo
			}
		}),
		[
			totalImages,
			images,
			selected,
			selectionAction,
			onLoadMore,
			useImageClientSize,
			isMultiple,
			allowSelect,
			customPreviewInfo,
			alwaysShowPreviewInfo,
			isImageLoaded
		],
	);
};
